import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "Home" */ "./views/Home.vue"),
    },
    {
      path: "/database",
      name: "database",
      component: () =>
        import(/* webpackChunkName: "Database" */ "./views/Database.vue"),
    },
    {
      path: "/glossary",
      name: "glossary",
      component: () =>
        import(/* webpackChunkName: "Glossary" */ "./views/Glossary.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "About" */ "./views/About.vue"),
    },
    {
      path: "/articles",
      name: "articles",
      component: () =>
        import(/* webpackChunkName: "Articles" */ "./views/Articles.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.articles.length === 0) {
          store.dispatch("loadArticles").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/articles/:uid",
      name: "article",
      props: true,
      component: () =>
        import(/* webpackChunkName: "Article" */ "./views/Article.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.articles.length === 0) {
          store.dispatch("loadArticles").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
